module.exports = __webpack_public_path__ + "img/resolve_v3.1b69bdf1.png";